import { useEffect, useState } from "react";
import Api from "../../utils/Api";
import {
  API_ROUTE_E_RETAIL_SPENDS,
  API_ROUTE_E_RETAIL_SPENDS_COMPUTE,
  API_ROUTE_E_RETAIL_SPENDS_DOWNLOAD,
  API_ROUTE_E_RETAIL_SPENDS_TRANSFER,
} from "../../routes";
import { debug } from "../../utils/helpers";

export function useSpends(auto = false) {
  const [isLoading, setIsLoading] = useState(false);
  const [spends, setSpends] = useState([]);

  const getSpends = (payload = {}, showLoader = true) => {
    setIsLoading(showLoader);

    return Api.post(API_ROUTE_E_RETAIL_SPENDS, {
      ...payload,
    })
      .then((response) => {
        setSpends(response.data.spends);
        return Promise.resolve(response.data.spends);
      })
      .catch((error) => {
        debug.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const computeSpends = (payload = {}, showLoader = true) => {
    setIsLoading(showLoader);

    return Api.post(API_ROUTE_E_RETAIL_SPENDS_COMPUTE, {
      ...payload,
    })
      .then((response) => {
        const responseIndex = spends.findIndex(
          (spend) => spend.spendId === response.data.spendId,
        );

        setSpends((prev) => {
          const next = [...prev];
          if (responseIndex < 0) {
            next.push(response.data);
          } else {
            next[responseIndex] = response.data;
          }
          return next;
        });
      })
      .catch((error) => {
        debug.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const transferSpends = (payload = {}, showLoader = true) => {
    setIsLoading(showLoader);

    return Api.post(API_ROUTE_E_RETAIL_SPENDS_TRANSFER, {
      ...payload,
    })
      .then((response) => {})
      .catch((error) => {
        debug.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const downloadSpends = (payload = {}, showLoader = true) => {
    setIsLoading(showLoader);

    return Api.post(API_ROUTE_E_RETAIL_SPENDS_DOWNLOAD, {
      ...payload,
    })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        debug.log(error);
        return Promise.reject(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!auto) {
      return;
    }
    getSpends({
      includeMetadata: false,
      yearMonths: new Array(12).fill(null).map((month, index) => ({
        year: new Date().getFullYear(),
        month: index + 1,
        includeProcessMessages: false,
      })),
    });
  }, [auto]);

  return {
    isLoading,
    spends,
    getSpends,
    computeSpends,
    transferSpends,
    downloadSpends,
  };
}
